var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoltDos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 312.5 118.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7c6cc9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R\\xE9teg_2",
    "data-name": "R\\xE9teg 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame_0",
    "data-name": "Frame 0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222,2.28,160.24,4.75,69.19,0,0,2.28S4.37,58.54,4.37,58.55L1.9,112.72l104.55,3.61L191.61,118l77.55-6.27,43.34.57-4.95-46.06s2.19-64.34,2.19-64.34Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoltDos);
export default __webpack_public_path__ + "static/media/FoltDos.c99d759670c4ca5911dc19b5d62f300e.svg";
export { ForwardRef as ReactComponent };